module.exports = __webpack_public_path__ + "static/media/circle-fill.5bd89116.png";